export * from "./profile-info-short.component";
